<template>
  <div>
    <period-selector
      title="Parâmetros de Seleção de Dados"
      sub-title="Selecione as opções de busca de dados"
      :default-start="DEFAULT_START"
      :default-end="DEFAULT_END"
      :show-loading="showLoading"
      @onClickFetch="fetchHoursCsv"
    />
  </div>
</template>

<script>
import { DateTime } from "luxon";

import { DateTimeFormats } from "../util/datetime.formats";

import PeriodSelector from "../components/PeriodSelector.vue";

import { userService } from "../_services/user.service";

export default {
  components: {
    PeriodSelector,
  },
  data() {
    return {
      showLoading: false,
    };
  },
  created() {
    this.DEFAULT_START = DateTime
      .now()
      .minus({ month: 1 })
      .startOf("month")
      .toFormat(DateTimeFormats.HTML_INPUT_DATETIME);

    this.DEFAULT_END = DateTime
      .now()
      .minus({ month: 1 })
      .endOf("month")
      .toFormat(DateTimeFormats.HTML_INPUT_DATETIME);
  },
  methods: {
    async fetchHoursCsv(selectedPeriod) {
      this.showLoading = true;

      const res = await userService
        .getFTECsv({
          start: DateTime.fromFormat(selectedPeriod.start, DateTimeFormats.HTML_INPUT_DATETIME).toISO(),
          end: DateTime.fromFormat(selectedPeriod.end, DateTimeFormats.HTML_INPUT_DATETIME).toISO(),
        })
        .catch((_) => null);

      if (!res || res.size === 0) {
        this.$notify({
          timeout: 2500,
          message: "Nenhum dado encontrado na busca...",
          type: "warning",
        });
        this.showLoading = false;
        return;
      }

      this.downloadCSV(res);

      this.showLoading = false;
    },
    downloadCSV(file) {
      const fileURL = URL.createObjectURL(new Blob([ file ]));
      const anchor = document.createElement("a");
      anchor.href = fileURL;
      anchor.target = "_blank";
      anchor.download = "export.csv";
      anchor.click();
    },
  },
};
</script>
